// Function to initialize a product
function initializeProduct(productId) {
  const productElement = document.querySelector(`[data-product-id="${productId}"]`);
  if (!productElement || productElement.dataset.initialized === 'true') return;

  productElement.dataset.initialized = 'true'; // Prevent re-initializing

  const colorSwatches = productElement.querySelectorAll(`.js-collection-swatch[data-product-id="${productId}"]`);
  const sizeContainer = document.getElementById(`size-selector-container-${productId}`);
  const addToCartButton = document.getElementById(`addToCart-${productId}`);
  const hiddenInput = document.getElementById(`selected-variant-id-${productId}`);
  const colorNameElement = productElement.querySelector('.swatch_color_name');

  // ✅ Ensure one swatch is selected
  let initiallySelectedSwatch = [...colorSwatches].find(s => s.classList.contains('selected'));

  // If none is selected, auto-select the first one
  if (!initiallySelectedSwatch && colorSwatches.length > 0) {
    initiallySelectedSwatch = colorSwatches[0];
    initiallySelectedSwatch.classList.add('selected', 'selected-swatch');

    if (colorNameElement) {
      colorNameElement.textContent = initiallySelectedSwatch.getAttribute('data-color-name') || 'Unknown';
    }

    const swatchUrl = initiallySelectedSwatch.dataset.swatchUrl;
    if (swatchUrl) {
      updateMainProduct(swatchUrl, productId);
    } else {
      console.warn(`Missing data-swatch-url on first swatch for product ${productId}`);
    }
  }

  // Visual cue for hero product layout
  if (colorSwatches.length > 1) {
    productElement.classList.add('full-width-hero-product');
  }

  // Add swatch click listeners
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      if (!swatch.classList.contains('selected')) {
        colorSwatches.forEach(s => s.classList.remove('selected', 'selected-swatch'));
        swatch.classList.add('selected', 'selected-swatch');

        if (colorNameElement) {
          colorNameElement.textContent = swatch.getAttribute('data-color-name') || 'Unknown';
        }

        const swatchUrl = swatch.dataset.swatchUrl;
        if (swatchUrl) {
          updateMainProduct(swatchUrl, productId);
        }
      }
    });
  });

  // Setup form submission for Add to Cart
  const form = document.getElementById(`product-frm-${productId}`);
  if (form && !form.dataset.bound) {
    form.dataset.bound = "true";
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: hiddenInput.value, quantity: 1 })
        });
        if (response.ok) showCartConfirmation(await response.json(), productId);
      } catch (error) {
        console.error('Error during Add to Cart request:', error);
      }
    });
  }
}


// Modify your add-to-cart success handler to trigger cart update event
function showCartConfirmation(variantData, productId) {
  const confirmationTemplate = document.getElementById('cart-confirmation-template');
  if (!confirmationTemplate) {
    console.error('Cart confirmation template not found');
    return;
  }

  // Clone the template
  const confirmationContainer = confirmationTemplate.cloneNode(true);
  confirmationContainer.style.display = 'block';
  confirmationContainer.id = ''; // Remove duplicate ID to avoid conflicts

  // Populate template with variant data
  confirmationContainer.querySelector('.cart-confirmation__image').src = variantData.image;
  confirmationContainer.querySelector('.cart-confirmation__image').alt = variantData.title;
  confirmationContainer.querySelector('.cart-confirmation__product-title span').innerText = variantData.product_title;
  confirmationContainer.querySelector('.cart-confirmation__variant-title span').innerText = variantData.title;
  confirmationContainer.querySelector('.cart-confirmation__size span').innerText = variantData.options[0];
  confirmationContainer.querySelector('.cart-confirmation__price span').innerText = Shopify.formatMoney(variantData.price);

  // Append to body
  document.body.appendChild(confirmationContainer);

  // Trigger custom event to update cart count
  const event = new Event('cart:update');
  document.body.dispatchEvent(event);

  // Hide confirmation after 3 seconds
  setTimeout(() => {
    document.body.removeChild(confirmationContainer);
  }, 3000);
}


// Function to update product sizes dynamically based on selected color
function updateMainProduct(productUrl, productId) {
  fetch(productUrl + '.js')
    .then(response => response.json())
    .then(data => {
      const sizeContainer = document.getElementById(`size-selector-container-${productId}`);
      const addToCartButton = document.getElementById(`addToCart-${productId}`);
      const hiddenInput = document.getElementById(`selected-variant-id-${productId}`);
      
      // Preserve the currently selected size
      const currentlySelectedSize = hiddenInput.value;

      sizeContainer.innerHTML = ''; // Clear existing sizes

      let firstAvailableSizeSelected = false;

      // Add sizes dynamically
      data.variants.forEach((variant, index) => {
        const trimmedVariantTitle = variant.title.split('/')[0].trim();

        const div = document.createElement('div');
        div.className = 'swatches__swatch--regular swatch-element js-swatch-element';
        if (!variant.available) div.classList.add('soldout');

        const input = document.createElement('input');
        input.type = 'radio';
        input.id = `template--${variant.id}--Size-${index}`;
        input.className = 'swatches__form--input';
        if (!variant.available) input.classList.add('soldout');
        input.name = `size-${productId}`;
        input.value = trimmedVariantTitle;
        input.setAttribute('data-variant-id', variant.id);
        input.setAttribute('data-available', variant.available);
        input.setAttribute('data-product-id', productId);
        if (!variant.available) input.disabled = true;

        // Auto-check the currently selected size if it matches
        if (currentlySelectedSize == variant.id) {
          input.checked = true;
          firstAvailableSizeSelected = true;

          // Update hidden input and Add to Cart button
          hiddenInput.value = variant.id;
          if (variant.available) {
            addToCartButton.disabled = false;
            addToCartButton.value = 'Add to Cart';
            addToCartButton.classList.remove('atc-soldOut');
          } else {
            addToCartButton.disabled = true;
            addToCartButton.value = 'Sold Out';
            addToCartButton.classList.add('atc-soldOut');
          }
        }

        // Auto-check the first available size if no match
        if (!firstAvailableSizeSelected && variant.available) {
          input.checked = true;
          firstAvailableSizeSelected = true;

          // Update hidden input and Add to Cart button
          hiddenInput.value = variant.id;
          addToCartButton.disabled = false;
          addToCartButton.value = 'Add to Cart';
          addToCartButton.classList.remove('atc-soldOut');
        }

        const label = document.createElement('label');
        label.className = 'swatches__form--label';
        label.setAttribute('for', `template--${variant.id}--Size-${index}`);
        label.setAttribute('tabindex', '0');
        label.innerText = trimmedVariantTitle;

        div.appendChild(input);
        div.appendChild(label);
        sizeContainer.appendChild(div);

        // Attach change event to input
        input.addEventListener('change', () => {
          if (input.checked) {
            hiddenInput.value = variant.id;

            if (variant.available) {
              addToCartButton.disabled = false;
              addToCartButton.value = 'Add to Cart';
              addToCartButton.classList.remove('atc-soldOut');
            } else {
              addToCartButton.disabled = true;
              addToCartButton.value = 'Sold Out';
              addToCartButton.classList.add('atc-soldOut');
            }
          }
        });
      });

      // Ensure at least one size is selected if all are unavailable
      if (!firstAvailableSizeSelected) {
        addToCartButton.disabled = true;
        addToCartButton.value = 'Sold Out';
        addToCartButton.classList.add('atc-soldOut');
      }
    })
    .catch(error => console.error('Error fetching product:', error));
}


// Show cart confirmation using template
function showCartConfirmation(variantData, productId) {
  const confirmationTemplate = document.getElementById('cart-confirmation-template');
  if (!confirmationTemplate) {
    console.error('Cart confirmation template not found');
    return;
  }

  // Clone the template
  const confirmationContainer = confirmationTemplate.cloneNode(true);
  confirmationContainer.style.display = 'block';
  confirmationContainer.id = ''; // Remove duplicate ID to avoid conflicts

  // Populate template with variant data
  confirmationContainer.querySelector('.cart-confirmation__image').src = variantData.image;
  confirmationContainer.querySelector('.cart-confirmation__image').alt = variantData.title;
  confirmationContainer.querySelector('.cart-confirmation__product-title span').innerText = variantData.product_title;
  confirmationContainer.querySelector('.cart-confirmation__variant-title span').innerText = variantData.title;
  confirmationContainer.querySelector('.cart-confirmation__size span').innerText = variantData.options[0];
  confirmationContainer.querySelector('.cart-confirmation__price span').innerText = Shopify.formatMoney(variantData.price);

  // Append to body
  document.body.appendChild(confirmationContainer);

  // Hide confirmation after 3 seconds
  setTimeout(() => {
    document.body.removeChild(confirmationContainer);
  }, 3000);
}

// Initialize all products on page load
document.addEventListener('DOMContentLoaded', () => {
  const products = document.querySelectorAll('.product');
  products.forEach(product => {
    const productId = product.dataset.productId;
    initializeProduct(productId);
  });
});










// JavaScript Function to Toggle Class
function toggleGridClass(value) {
  const gridElement = document.querySelector(".product-loop");

  if (gridElement) {
    gridElement.classList.remove("collection__page-products", "collection__page-products-3", "collection__page-products-1");
    
    if (value === "1") {
      gridElement.classList.add("collection__page-products-1");
    } else if (value === "2") {
      gridElement.classList.add("collection__page-products");
    } else if (value === "3") {
      gridElement.classList.add("collection__page-products-3");
    }
  }
}

// Ensure the slider is only declared once and attach the event listener safely
document.addEventListener("DOMContentLoaded", () => {
  const slider = document.getElementById("gridToggleSlider");

  if (slider && !slider.dataset.bound) {
    slider.dataset.bound = "true";
    slider.addEventListener("input", function () {
      toggleGridClass(this.value);
    });
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;

  // Function to handle modal functionality
  function bindModalFunctionality() {
    // Open modal
    document.querySelectorAll('.openModal').forEach(button => {
      if (!button.dataset.bound) {
        button.dataset.bound = "true";
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const modalOverlay = button.nextElementSibling;
          if (modalOverlay) {
            modalOverlay.style.display = 'flex';
            body.style.overflow = 'hidden';
            const productId = button.dataset.productId;
            if (productId) {
              initializeProduct(productId);
            }
          }
        });
      }
    });
    

    // Close modal using close button
    document.querySelectorAll('.close').forEach(closeButton => {
      if (!closeButton.dataset.bound) {
        closeButton.dataset.bound = "true"; // Avoid rebinding
        closeButton.addEventListener('click', () => {
          const modalOverlay = closeButton.closest('.modal-overlay');
          if (modalOverlay) {
            modalOverlay.style.display = 'none'; // Hide modal
            restoreScrolling(); // Restore page scroll
          }
        });
      }
    });

    // Close modal on clicking outside the modal content
    document.querySelectorAll('.modal-overlay').forEach(modalOverlay => {
      if (!modalOverlay.dataset.bound) {
        modalOverlay.dataset.bound = "true"; // Avoid rebinding
        modalOverlay.addEventListener('click', (e) => {
          if (e.target === modalOverlay) {
            modalOverlay.style.display = 'none'; // Hide modal
            restoreScrolling(); // Restore page scroll
          }
        });
      }
    });
  }

  // Function to restore scrolling
  function restoreScrolling() {
    const openModals = document.querySelectorAll('.modal-overlay[style*="display: flex"]');
    if (openModals.length === 0) {
      body.style.overflow = ''; // Allow page scrolling only if no modals are open
    }
  }

  // Function to monitor DOM changes and bind modal events
  function observeDomChanges() {
    const observer = new MutationObserver(() => {
      bindModalFunctionality(); // Rebind modal functionality for new elements
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Bind initial modal functionality
  bindModalFunctionality();

  // Observe DOM changes for dynamically added content (e.g., pagination)
  observeDomChanges();

// pagination listener section code start

document.body.addEventListener('click', event => {
  const link = event.target.closest('[st-pagination="true"]'); 
  if (link) {
    // Pagination has occurred, wait for the delay
    setTimeout(() => {
      // Bind modal functionality
      bindModalFunctionality();
      document.body.addEventListener('cart:update', () => {
  updateCartCount();
});

      // Initialize products
      const products = document.querySelectorAll('.product');
      products.forEach(product => {
        const productId = product.dataset.productId;
        initializeProduct(productId);
      });
      
    }, 3000);
  }
});
  
// pagination listener section code ends
  
});


// Function to initialize confirmation sections and other details
function initializeSections() {
  document.addEventListener("DOMContentLoaded", () => {
    const confirmationSections = document.querySelectorAll(".confirmation-section");
    confirmationSections.forEach((section) => {
      section.style.display = "none";
    });

    setupModalCloseListeners();
    setupPaginationListener();

  });
}

// Function to set up event listeners for modal close buttons
function setupModalCloseListeners() {
  const modalCloseButtons = document.querySelectorAll(".openModal");

  modalCloseButtons.forEach((button) => {
    // Ensure no duplicate event listeners
    button.removeEventListener("click", handleModalClose);
    button.addEventListener("click", handleModalClose);
  });
}

// Modal close event handler
function handleModalClose(event) {
  event.preventDefault();
  closePopUpConfirmation();
}

// Function to close the popup and clear the confirmation section
function closePopUpConfirmation() {
  const confirmationSections = document.querySelectorAll(".confirmation-section");

  confirmationSections.forEach((section) => {
    const modalBody = section.closest(".modal-body-content");
   
    if (modalBody) {
      // Remove the confirmation-visible class from modal body
      modalBody.classList.remove("confirmation-visible");
    }
  const pricingContainer = modalBody.querySelector(".pricing-details-container");
      if (pricingContainer) {
        pricingContainer.style.display = "none";
      }
    
    section.style.display = "none";
    section.querySelector(".product-name").textContent = "";
    section.querySelector(".product-size").textContent = "";
    section.querySelector(".product-color").textContent = "";
    section.querySelector(".product-image").src = "";

    const prodColorsSection = modalBody.querySelector(".prod-colors");
    if (prodColorsSection) {
      prodColorsSection.style.display = "block";
    }

    const productDetailsSection = modalBody.querySelector(".product-details");
    if (productDetailsSection) {
      productDetailsSection.style.display = "block";
    }
  });

}

// Function to set up pagination listener
function setupPaginationListener() {
  document.body.removeEventListener("click", handlePaginationClick);
  document.body.addEventListener("click", handlePaginationClick);
}

// Pagination click event handler
function handlePaginationClick(event) {
  const link = event.target.closest("[st-pagination='true']");
  if (link) {
    setTimeout(() => {
      setupModalCloseListeners();
      updatePricingDetails();
      handleGoBackButtonClick();
    }, 3000);
  }
}

// Function to override fetch API for /cart/add.js calls
function overrideFetch() {
  if (window.fetch.isOverridden) return;

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const [resource, config] = args;

    if (resource.includes("/cart/add.js") && config?.method === "POST") {
      try {
        const response = await originalFetch(...args);
        const responseClone = response.clone();
        const jsonData = await responseClone.json();


        return response;
      } catch (error) {
        console.error("Error intercepting /cart/add.js call:", error);
      }
    }

    return originalFetch(...args);
  };

  window.fetch.isOverridden = true;
}

// Function to update the pricing details
function updatePricingDetails(productID) {
  setTimeout(() => { // Small delay to let other scripts execute first
    const selectedColorSwatches = document.querySelectorAll(`.prod-colors .js-collection-swatch.selected`);

    selectedColorSwatches.forEach((selectedColorSwatch) => {
      const modalBody = selectedColorSwatch.closest(".modal-body-content");
      if (!modalBody) {
        console.error("No modal-body-content found for the active color swatch.");
        return;
      }

      // Retrieve the pricing details container
      const pricingContainer = modalBody.querySelector(".pricing-details-container");
      if (!pricingContainer) {
        console.error("No pricing-details-container found in the modal.");
        return;
      }

      // Find the active size inside the selected color swatch
      const activeSizeElement = selectedColorSwatch.closest(".col-swatch")
        ?.querySelector(".swatch-element.selected-swatch input");

      // Get price details from active size, fallback to selected color if not found
      const mrp = activeSizeElement?.getAttribute("data-mrp") || selectedColorSwatch.getAttribute("data-mrp") || "₹0";
      const sellingPrice = activeSizeElement?.getAttribute("data-selling-price") || selectedColorSwatch.getAttribute("selling-price") || "₹0";

      // Convert prices to numbers by removing currency symbols and parsing
      const mrpValue = parseFloat(mrp.replace(/[₹,]/g, "")) || 0;
      const sellingPriceValue = parseFloat(sellingPrice.replace(/[₹,]/g, "")) || 0;

      // Calculate the difference amount
      const differenceAmount = `₹${(mrpValue - sellingPriceValue).toFixed(2)}`;

      // Calculate the difference percentage with percentage symbol
      const differencePercentage = mrpValue > 0
        ? `(${Math.round(((mrpValue - sellingPriceValue) / mrpValue) * 100)}% OFF)`
        : "(0% OFF)";

      // Select the elements inside the pricing details container to update prices
      const mrpElement = pricingContainer.querySelector(".compare-at-price");
      const sellingPriceElement = pricingContainer.querySelector(".base-price");
      const differenceAmountElement = pricingContainer.querySelector(".savings-amount");
      const differencePercentageElement = pricingContainer.querySelector(".savings-percentage");

      if (mrpElement) {
        mrpElement.setAttribute("data-force-update", "true"); // Add attribute to avoid overrides
        mrpElement.innerText = `₹${mrpValue.toFixed(2)}`;
      } else {
        console.error("MRP element not found.");
      }

      if (sellingPriceElement) {
        sellingPriceElement.setAttribute("data-force-update", "true");
        sellingPriceElement.innerText = `₹${sellingPriceValue.toFixed(2)}`;
      } else {
        console.error("Selling price element not found.");
      }

      if (differenceAmountElement) {
        differenceAmountElement.setAttribute("data-force-update", "true");
        differenceAmountElement.innerText = differenceAmount;
      } else {
        console.error("Savings amount element not found.");
      }

      if (differencePercentageElement) {
        differencePercentageElement.setAttribute("data-force-update", "true");
        differencePercentageElement.innerText = differencePercentage;
      } else {
        console.error("Savings percentage element not found.");
      }
    });
  }, 10); // Small delay to avoid other script overrides
}


document.addEventListener("DOMContentLoaded", () => updatePricingDetails());
document.addEventListener("click", () => updatePricingDetails()); 

// Function to handle go-back-button click
function handleGoBackButtonClick() {
  const goBackButtons = document.querySelectorAll(".go-back-button");
  goBackButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const modalBody = button.closest(".modal-body-content");
      if (!modalBody) {
        console.error("No modal-body-content found for go-back-button.");
        return;
      }

      const confirmationSection = modalBody.querySelector(".confirmation-section");
      const pricingDetailsContainer = modalBody.querySelector(".pricing-details-container");

      if (confirmationSection && pricingDetailsContainer) {
        confirmationSection.style.display = "block";
        pricingDetailsContainer.style.display = "none";
        modalBody.classList.remove("pricing-visible");
      }
    });
  });
}



// Function to initialize all functionality
function initializeAll() {
  initializeSections();
  overrideFetch();
}

// Call the initialization function
initializeAll();
